// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__+K0gE","heading":"Gallery_heading__OiFVf","container":"Gallery_container__w0cgK"};